// extracted by mini-css-extract-plugin
export default {"pdf-viewer":"Pdf_pdf-viewer__vsqZv","error":"Pdf_error__sfhgu","loader-wrapper":"Pdf_loader-wrapper__KDOf+"};